var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyRbIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.774,
    height: 24.774,
    viewBox: "0 0 24.774 24.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "why-icon-2",
    d: "M8.764,6.573l-3.1-3.1H4.119V5.025l3.1,3.1Zm1.548-4.645h1.548v3.1H10.313ZM16.506,9.67h3.1v1.548h-3.1Zm1.548-4.645V3.476H16.506l-3.1,3.1,1.548,1.548ZM2.571,9.67h3.1v1.548h-3.1Zm7.742,6.193h1.548v3.1H10.313Zm-6.193,0v1.548H5.667l3.1-3.1L7.216,12.767Zm22.887,7.4L11.616,7.877a1.165,1.165,0,0,0-1.642,0L8.519,9.331a1.165,1.165,0,0,0,0,1.642l15.39,15.39a1.165,1.165,0,0,0,1.642,0l1.454-1.454A1.165,1.165,0,0,0,27.006,23.266ZM14.183,15.089,9.538,10.444,11.087,8.9l4.645,4.645Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyRbIcon2);
export default __webpack_public_path__ + "static/media/why-rb-icon-2.0b32c3cfeb8425cfbb8dc6d92156735b.svg";
export { ForwardRef as ReactComponent };